import { DropdownOpenKeys, DropdownInteractiveKeys } from '@pff-consumer/schema'

export const getKeyDownInfo = (key: string, isModalOpen: boolean) => {
  const openKeys = DropdownOpenKeys
  const isAlphaNumericKey = /^[a-z0-9]$/.test(key)
  const isAnOpenKeyPress = openKeys.includes(key as DropdownInteractiveKeys)

  return {
    isAlphaNumericKey,
    canOpenUsingKey: !isModalOpen && isAnOpenKeyPress,
  }
}
